import { ArrowBack } from "@mui/icons-material";
import { ButtonV3 } from "gf-ui-components-mui-lib";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../organisms/generateClient/styles.module.scss";
import { useTableContext } from "../../../context/tableContext";
import GenerateIconWhite from "../../../assets/img/generate-white.svg";
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material";

export const GenerateHeader = ({
  showNext,
  showGenerate,
  nextButton,
  generateButton,
  closeButton,
  step,
  arrowBack,
  wareHouse = false,
}: {
  showNext: boolean;
  showGenerate: boolean;
  nextButton?: any;
  generateButton: any;
  selectedRowsLength?: number;
  arrowBackButton?: any;
  closeButton?: any;
  step?: any;
  setStep?: any;
  arrowBack?: any;
  dataList?: any;
  wareHouse?: boolean;
}) => {
  const {
    selectedRows,
    selectedRowsWithPage,
    arrowBackButtonHandler,
    selectedIds,
  } = useTableContext();
  const selectedCount =
    (selectedIds?.size ?? 0) ||
    (selectedRowsWithPage?.length ?? 0) ||
    (selectedRows?.length ?? 0);

  const dataListFinal = selectedRows?.length
    ? selectedRows
    : selectedRowsWithPage;
  const theme = useTheme();

  const isFormValid = (formData: any) => {
    const data: any = !wareHouse
      ? {
          vendorOrderId: formData?.vendorOrderId,
          vendor: formData?.vendor,
          model: formData?.model,
          chargerType: formData?.chargerType,
          connectors: formData?.connectors,
          ocppVersion: formData?.ocppVersion,
          //vendorNotes: formData?.vendorNotes,
        }
      : {
          clientOrderNo: formData?.clientOrderNo,
          clientName: formData?.clientName,
        };

    for (const field in data) {
      if (
        data[field] === "" ||
        data[field] === null ||
        data[field] === undefined
      ) {
        return true;
      }
    }
    return false;
  };

  return (
    <div className={`${styles.container}`}>
      {step !== 1 && (
        <IconButton
          onClick={arrowBack ? arrowBack : arrowBackButtonHandler}
          sx={{
            background: "#FFFFFF",
            padding: "8px 10px",
            borderRadius: "8px",
            border: "1px solid var(--gray-400, #C2C2C2)",
            color: "#000000",
            margin: "0px",
            height: "40px",
            "@media (max-width: 1440px)": {
              padding: "8px",
              fontSize: "12px",
              height: "30px",
            },
            "@media (max-width: 1336px)": {
              fontSize: "10px",
            },
            "&:hover": {
              background: "#FFFFFF",
              color: "#000000",
            },
          }}
          className="arrow-back-btn"
        >
          <ArrowBack
            sx={{
              fontSize: "1.5rem",
              [theme.breakpoints.down(1441)]: {
                fontSize: "1.25rem",
              },
              [theme.breakpoints.down(1367)]: {
                fontSize: "1rem",
              },
            }}
          />
        </IconButton>
      )}

      {showNext ? (
        <ButtonV3
          onClick={nextButton}
          disabled={selectedCount === 0}
          startIcon={
            <img
              src={GenerateIconWhite}
              alt=""
              className="imageContainerResponsive"
            />
          }
          sx={{
            background: "#3D3AD3",
            color: "#FFFFFF",
            margin: "0px",
            height: "40px",
            "@media (max-width: 1440px)": {
              fontSize: "12px",
              height: "30px",
            },
            "@media (max-width: 1336px)": {
              fontSize: "10px",
            },
            "&.Mui-disabled": {
              opacity: 0.5,
              background: "#3D3AD3",
              color: "#FFFFFF",
            },
            "&:hover": {
              background: "#3D3AD3",
              color: "#FFFFFF",
            },
          }}
          id="next-btn"
        >
          Next
        </ButtonV3>
      ) : showGenerate ? (
        <ButtonV3
          onClick={generateButton}
          startIcon={
            <img
              src={GenerateIconWhite}
              alt=""
              style={{
                [theme.breakpoints.down(1441)]: {
                  width: "10px",
                },
                [theme.breakpoints.down(1367)]: {
                  width: "10px",
                },
              }}
              className="imageContainerResponsive"
            />
          }
          disabled={isFormValid(
            dataListFinal?.length > 0 ? dataListFinal[0] : ""
          )}
          sx={{
            background: "#3D3AD3",
            color: "#FFFFFF",
            margin: "0px",
            height: "40px",
            "@media (max-width: 1440px)": {
              padding: "12px",
              fontSize: "12px",
              height: "30px",
            },
            "@media (max-width: 1336px)": {
              fontSize: "10px",
            },
            "&.Mui-disabled": {
              opacity: 0.5,
              background: "#3D3AD3",
              color: "#FFFFFF",
            },
            "&:hover": {
              background: "#3D3AD3",
              color: "#FFFFFF",
            },
          }}
          id="generate-btn"
        >
          Generate
        </ButtonV3>
      ) : null}
      <IconButton
        onClick={closeButton}
        sx={{
          background: "#D92D20",
          color: "#FFFFFF",
          padding: "8px 10px",
          borderRadius: "8px",
          border: "1px solid var(--gray-400, #C2C2C2)",
          margin: "0px",
          height: "40px",
          "@media (max-width: 1440px)": {
            fontSize: "12px",
            padding: "8px",
            height: "30px",
          },
          "@media (max-width: 1336px)": {
            fontSize: "10px",
          },
          "&:hover": {
            background: "#D92D20",
          },
        }}
        className="cross-icon-btn"
      >
        <CloseIcon
          sx={{
            fontSize: "1.5rem",
            [theme.breakpoints.down(1441)]: {
              fontSize: "1.25rem",
            },
            [theme.breakpoints.down(1367)]: {
              fontSize: "1rem",
            },
          }}
        />
      </IconButton>
    </div>
  );
};
